export const GetFormattedPointMultiplierData = (apiResponse = {}) => {
  const {
    data = [],
    totalRecords = '',
    totalPages = '',
    activeCount = '',
    currentPage = '',
    pageSize = ''
  } = apiResponse;

  const formattedPointMultiplier = data?.map(GetPointMultiplierData);

  return {
    data: formattedPointMultiplier,
    totalRecords,
    totalPages,
    activeCount,
    currentPage,
    pageSize
  };
};

// Helper function to map individual items
const GetPointMultiplierData = (item = {}) => {
  const {
    id = null,
    multiplierName = '',
    userSegment = '',
    productCategory = null,
    orderChannel = null,
    startDate,
    endDate,
    status = null,
    rulesPriority = 0,
    multiplierValue = '',
    uuid = null
  } = item;

  return {
    id,
    multiplierName,
    userSegment: userSegment,
    productCategory,
    orderChannel,
    startDate: startDate,
    endDate: endDate,
    status,
    rulesPriority,
    multiplierValue,
    uuid
  };
};
